import React from "react";
import { getFlagUrl } from "./Utils/getFlagUrl";

const OmniumMobile = ({ data, boldRows, rowRange, discipline }) => {
  const isSpacer = (row) => row.every((cell) => !cell || cell.trim() === "");

  const renderRiderRow = (row, index) => {
    const rowNumber = rowRange[0] + index + 1;
    const isBold = boldRows.includes(rowNumber);
    const rank = row[0] || "";
    const lastName = row[2] || "";
    const firstName = row[3] || "";
    const country = row[4] || "";
    const totalPoints = row[12] || "";

    // Omnium sub-results: Scratch Rnk|Pts (5|6), Tempo (7|8), Elimination (9|10), Points Race (only 1 col: 11)
    const scratch = row[5] && row[6] ? `${row[5]} | ${row[6]}` : "";
    const tempo = row[7] && row[8] ? `${row[7]} | ${row[8]}` : "";
    const elimination = row[9] && row[10] ? `${row[9]} | ${row[10]}` : "";
    const pointsRace = row[11] || "";

    return (
      <div key={index} className={`sqm-row ${isBold ? "bold-row" : ""}`}>
        <div className="sqm-rank">{rank}</div>
        <div className="sqm-left">
          <div className="sqm-last-name">{lastName}</div>
          <div className="sqm-first-name">{firstName}</div>
          <div className="omnium-sub-results">
            {scratch && <div className="omnium-sub">{scratch}</div>}
            {tempo && <div className="omnium-sub">{tempo}</div>}
            {elimination && <div className="omnium-sub">{elimination}</div>}
            {pointsRace && <div className="omnium-sub">{pointsRace}</div>}
          </div>
        </div>
        <div className="sqm-right">
          <img src={getFlagUrl(country)} alt={country} className="flag-icon" />
          <div className="sqm-time">{totalPoints}</div>
        </div>
      </div>
    );
  };

  return (
    <div className="mobile-omnium">

      {data.map((row, index) => {
        if (isSpacer(row)) return null;
        const isHeaderRow =
  (row[0]?.toLowerCase() === "rnk" && row[2]?.toLowerCase() === "last name") ||
  (row[6]?.toLowerCase() === "scratch" && row[7]?.toLowerCase() === "om. points");

        if (isHeaderRow) return null;
        return renderRiderRow(row, index);
      })}
    </div>
  );
};

export default OmniumMobile;
